import { Box, Button, Dialog, Theme, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router';
import OTPForm from '../lib/formik/OtpForm';
import { useDispatch } from 'react-redux';
import { paymentOpenFlowResendOtp, paymentOpenFlowValOtp, resendOtp, validateOtp } from '../redux-store/actions/cart';
import { OtpResponseMessage, ResendOtpResponseBody, ValidateOtpResponseBody } from '../redux-store/types/cart';
import { getRoleBasedPermissions, showError } from '../redux-store/actions/auth';
import { SuccessIcon } from '../assets/SvgIcons';
import { storeIwappId } from '../redux-store/actions/id';
import { VERIFY_LOGIN_OTP_SUCCESS } from '../redux-store/types/auth';
import { GetRoleBasedPermissionsResponseBody } from '../redux-store/types/api-types';

export default function GetAndVerifyPaymentOtp(): JSX.Element {
    const { params, url } = useRouteMatch();
    const { paymentId } = params as unknown as { paymentId: string };
    const history = useHistory();
    const { cartId, otpResponseMessages, clientCode, portfolioId } = history.location.state as unknown as { cartId: string, otpResponseMessages: OtpResponseMessage[], clientCode: string, portfolioId: string };

    const dispatch = useDispatch();
    const [paymentNotRequired, setPaymentNotRequired] = useState<boolean>(false);
    const [paymentFalseMessage, setPaymentFalseMessage] = useState<string>('');
    const theme = useTheme();


    const handleSubmit = async (otp: string, id: number) => {
        const payload = {
            otp,
            token: paymentId ?? "",
            id: `${id}`,
            cartId: cartId ?? ""
        }

        const response = await (dispatch(paymentOpenFlowValOtp(payload)) as unknown as Promise<ValidateOtpResponseBody>)

        if (response?.isSuccess) {
            if (response?.cartId) {
                const permissionResponse = await dispatch(getRoleBasedPermissions({
                    temporaryToken: response?.login_token ?? ""
                }) as unknown as Promise<GetRoleBasedPermissionsResponseBody>)

                dispatch(storeIwappId({ iwappRmId: response?.orders?.[0]?.rmId ?? "" }));
                if (response?.paymentRequired) {
                    history.replace('payment', {
                        cartId: response?.cartId ?? "",
                        token: response?.token ?? "",
                        clientCode,
                        portfolioId,
                        login_token: response?.login_token
                    })

                    dispatch({
                        type: VERIFY_LOGIN_OTP_SUCCESS,
                        body: {
                            permissions: permissionResponse?.permissions[`${response?.role ?? ""}`.toLowerCase()] ?? permissionResponse?.permissions[`${response?.role ?? ""}`.toUpperCase()] ?? []
                        }
                    })
                } else {
                    setPaymentFalseMessage(response?.message ?? "");
                    setPaymentNotRequired(true);
                }
            } else {
                const otpResponse = otpResponseMessages?.map(item =>
                    item.id === response?.id ? { id: response.id, isVerified: true, message: response?.message } : item
                );
                history.replace({
                    pathname: url,
                    state: { cartId, otpResponseMessages: otpResponse, clientCode, portfolioId }  //updating id in location:state if resend otp is success
                }); 
            }

        }
        if (!response?.isSuccess) {
            dispatch(showError(response?.message ?? ""))
        }
    }

    const handleResend = async (id: number) => {
        const payload = {
            cartId: cartId ?? "",
            id: id ? `${id}` : "",
            token: paymentId ?? ""
        }

        const response = await (dispatch(paymentOpenFlowResendOtp(payload)) as unknown as Promise<ResendOtpResponseBody>)

        if (response?.isSuccess) {
            const otpResponse = otpResponseMessages?.map(item =>
                item.id === response?.requestForId ? { ...item, id: response.id, maximum_attempts: response?.maximum_attemps, failed_attempts: response?.failed_attempts, message: response?.message, numberOfOTPTries: response?.numberOfOTPTries } : item
            );
            // setOtpMessage(response?.message ?? "");
            history.replace({
                pathname: url,
                state: { cartId, otpResponseMessages: otpResponse, clientCode, portfolioId }  //updating id in location:state if resend otp is success
            });
        }
    }

    const handlePaymentFalsePopup = () => {
        setPaymentNotRequired(false);
        history.replace('/investor-dashboard');
    }

    return (
        <>
            <Box sx={{ padding: '30px 45px' }}>
                <Typography
                    variant="h1"
                    sx={(theme: Theme) => ({
                        lineHeight: "32.5px",
                        color: theme.palette.text.primary
                    })}
                >
                    Transaction Confirmation
                </Typography>
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        borderRadius: "20px",
                        backgroundColor: theme.palette.common.white,
                        padding: "50px",
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: 'column',
                        gap: 2,
                    })}
                >
                    {otpResponseMessages?.map((item, idx) => {
                        return (
                            <Box key={idx} sx={{ width: "50%", border: `1px solid ${theme.palette.text.secondary}`, p: 3, borderRadius: '20px' }}>
                                {item.isVerified
                                    ? <Typography>{item.message}</Typography>
                                    : <OTPForm
                                        onSubmit={(otp) => handleSubmit(otp, item.id)}
                                        onResend={() => handleResend(item.id)}
                                        otpMessage={item.message ?? ''}
                                        numberOfTries={item?.numberOfOTPTries ?? 0}
                                        warningMessage=""
                                    />
                                }
                            </Box>)
                    })}
                </Box>
            </Box>
            <Dialog
                onClose={() => setPaymentNotRequired(false)}
                open={paymentNotRequired}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                        <SuccessIcon />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Success!
                        </Typography>
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center"
                            })}
                        >
                            {paymentFalseMessage}
                        </Typography>
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={handlePaymentFalsePopup}
                        >
                            Go To Dashboard
                        </Button>
                    </Box>
                </Box>

            </Dialog>
        </>
    )
}
